import { render, staticRenderFns } from "./ModalClinicalData.vue?vue&type=template&id=9f9a7276&scoped=true"
import script from "./ModalClinicalData.vue?vue&type=script&lang=js"
export * from "./ModalClinicalData.vue?vue&type=script&lang=js"
import style0 from "./ModalClinicalData.vue?vue&type=style&index=0&id=9f9a7276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9a7276",
  null
  
)

export default component.exports